import Layout from '@/components/layout';
import Image from 'next/image';
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm';
import { Pages } from '@/lib/seoData';
import { withServerSideProps, WithGetServerSidePropsContext, NextSSRPage } from 'hoc/withServerSideProps';

const ForgotPasswordPage: NextSSRPage = (props) => {
  return (
    <Layout {...props} isSignUp>
      <div className="w-full md:min-h-[600px] relative">
        <div className="relative w-full bg-gradient-to-b from-transparent z-20 md:to-black/75 md:py-16">
          <div className="bg-white md:max-w-[530px] mx-auto p-8 lg:ml-[100px] lg:mr-[100px] border w-full mb-0">
            <ForgotPasswordForm />
          </div>
        </div>
        <span className="hidden md:block">
          <Image
            src="/images/hero-image-2.png"
            alt="Placeholder"
            layout="fill"
            objectFit="cover"
            objectPosition="center top"
            className="bg-black"
          />
        </span>
      </div>
    </Layout>
  );
};

export const getServerSideProps = withServerSideProps(async function (context: WithGetServerSidePropsContext) {
  const { accessToken } = context.props;
  if (accessToken) {
    return {
      redirect: {
        destination: '/',
        permanent: false
      }
    };
  }
  return {
    props: {}
  };
}, Pages.FORGOT_PASSWORD)

export default ForgotPasswordPage;
